import { Dispatch, FC, Fragment, useEffect, useState } from "react";
import { Box, FormControl, Grid, InputLabel, Select, Stack, TextField, Typography } from "@mui/material";
import { useStyles } from '../styles';
import { LoadingButton } from "@mui/lab";
import AddIcon from '@mui/icons-material/Add';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { DataRef } from "../../../types/DataRef";
import { AlertType } from "../../../types/AlertType";
import { AxiosInstance } from "axios";
import CheckAttr from "../../../utils/CheckAttr";
import { DataSaisieManager, IPeriodeCloture, PeriodSaisi } from "../../content/production/SaisieAgent";
import dateFormat from "dateformat";
import { PROFIL_COUNTRY_MANAGER, PROFIL_MANAGER, PROFIL_ROA, codeArticleNotToDisable, PROFIL_GESTIONNER_HEURE_PROD, deviseIds_fixed3, PROFIL_ADV, articlesSansActes } from '../../../constants/Constants';
import { ConnectedUser, checkViaCodeArticle } from '../../../utils/utils';

interface SaisieAgentToSave {
    id?: number;
    pays?: number;
    client?: number;
    operation?: number;
    article?: number;
    code_article_libelle: string;
    date_saisie?: Date;
    heuresprod?: string;
    heures_ca?: string;
    actes?: number;
    dmt?: string;
}

interface InputValidation {
    pays: boolean;
    client: boolean;
    operation: boolean;
    article: boolean;
    date_saisie: boolean;
    value: boolean;
}

interface SaisieAgentFormProps {
    onClose: () => void;
    saisieAgent?: DataSaisieManager;
    periodSaisi: PeriodSaisi;
    dataPays: DataRef[];
    http: AxiosInstance;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
    allPeriodeClotured: IPeriodeCloture[]
    reloadList: () => void;
}

const resetSaisieAgentToSave: SaisieAgentToSave = {
    id: undefined,
    pays: undefined,
    client: undefined,
    operation: undefined,
    article: undefined,
    code_article_libelle: "",
    date_saisie: undefined,
    heuresprod: '',
    heures_ca: '',
    actes: undefined,
    dmt: ''
}

const resetInpuValidation: InputValidation = {
    pays: false,
    client: false,
    operation: false,
    article: false,
    date_saisie: false,
    value: false
};

const SaisieAgentForm: FC<SaisieAgentFormProps> = ({
    dataPays,
    saisieAgent,
    periodSaisi,
    http,
    onClose,
    reloadList,
    setOpenSnack,
    setAlerteMessage,
    setAlertType,
    allPeriodeClotured
}) => {
    const classes = useStyles();

    const user = ConnectedUser();
    const profil = user?.profils?.libelle;

    const [isClickSave, setIsClickSave] = useState<boolean>(false);

    const [dataClients, setDataClients] = useState<DataRef[]>([]);
    const [dataOperations, setDataOperations] = useState<DataRef[]>([]);
    const [dataArticles, setDataArticles] = useState<DataRef[]>([]);
    const [saisieAgentToSave, setSaisieAgentToSave] = useState<SaisieAgentToSave>(resetSaisieAgentToSave);
    const [errorInput, setErrorInput] = useState<InputValidation>(resetInpuValidation);

    // Heures de management non facturées : actes toujours à 0
    const sansActes = articlesSansActes.includes(saisieAgent?.article_libelle as string);

    //Chiffre Apres Virgule
    const chiffreApresVirgule = deviseIds_fixed3.includes(saisieAgent?.devises_id as number) ? 3 : 2

    /* const [periodSaisi, setPeriodSaisi] = useState<PeriodSaisi>({
        date_debut: '',
        date_fin: ''
    }); */

    /* const getDatePeriodSaisi = async () => {
        // Déterminer la période auquel je peut saisir des quantités
        await http.post('saisie/manager/get-period-to-enter/quantities', {
            referenceDate: saisieAgent?.date_saisie
        }).then(res => {
            setPeriodSaisi(res?.data?.period_saisi);
        }).catch(error => {
            console.log(error);
        });
    }; */

    useEffect(() => {
        if (saisieAgentToSave?.pays && saisieAgentToSave?.client && saisieAgentToSave?.operation) {
            // Récupère les articles
            http.post('article/findby-pays-client-operation', {
                pays: saisieAgentToSave?.pays,
                client: saisieAgentToSave?.client,
                operation: saisieAgentToSave?.operation,
                date_saisie: saisieAgentToSave?.date_saisie,
                mode: 'UPDATE',
                action: "saisieManager"
            }).then(res => {
                Array.isArray(res.data.operations) && setDataArticles(res.data.operations);
            }).catch(error => {
                console.log(error);
            });
        } else {
            setSaisieAgentToSave({
                ...saisieAgentToSave,
                operation: undefined
            });
            setDataOperations([]);
        }
    }, [saisieAgentToSave?.operation]);

    useEffect(() => {
        if (saisieAgent) {
            setDataClients([{
                id: saisieAgent?.client_id,
                libelle: saisieAgent?.client_libelle
            }]);

            setDataOperations([{
                id: saisieAgent?.operation_id,
                libelle: saisieAgent?.operation_libelle
            }]);

            const saisieAgentToUpdate: SaisieAgentToSave = {
                id: saisieAgent?.id,
                pays: saisieAgent?.pays_id,
                client: saisieAgent?.client_id,
                operation: saisieAgent?.operation_id,
                article: saisieAgent?.article_id,
                code_article_libelle: saisieAgent?.code_article_libelle,
                date_saisie: saisieAgent?.date_saisie,
                heuresprod: saisieAgent?.heuresprod,
                heures_ca: saisieAgent?.heures_ca,
                actes: sansActes ? 0 : saisieAgent?.actes,
                dmt: saisieAgent?.dmt
            };

            setSaisieAgentToSave(saisieAgentToUpdate);
        }
    }, []);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        // teste Date Cloture Si ADMIN
        if (name === 'date_saisie' && ![PROFIL_MANAGER, PROFIL_COUNTRY_MANAGER, PROFIL_ROA].includes(profil)) {

            let TesteSiValueInDateDisable = false;
            allPeriodeClotured.map((dateTmp) => {
                // Si Le Value est Inclu Dans L'un des Periode Cloture
                if (value >= dateTmp.date_debut && value <= dateTmp.date_fin) {
                    // Disable
                    setAlerteMessage(
                        `le ${dateTmp.date_debut} a ${dateTmp.date_fin} est Deja Cloturé`
                    );
                    setAlertType("warning");
                    setOpenSnack(true);

                    TesteSiValueInDateDisable = true;
                }
            })

            if (!TesteSiValueInDateDisable) {
                // Si il n'est pas Inclue Dans Tout les Periode Clotures
                setSaisieAgentToSave({
                    ...saisieAgentToSave,
                    [name]: value,
                });
            } else {
                setSaisieAgentToSave({
                    ...saisieAgentToSave,
                    [name]: '',
                });
            }

        } else {
            setSaisieAgentToSave({
                ...saisieAgentToSave,
                [name]: value,
            });
        }
    }

    const isValidate = (): boolean => {
        // Reinitialise les variables des validations
        setErrorInput(resetInpuValidation);

        /**
         * Verification si l'utilisateur a au moins rempli
         * l'heure de production ou actes ou heures de formation
         */
        let isVal = true;
        if (sansActes) {
            // Actes à 0 : l'heure de production est obligatoire
            isVal = CheckAttr(saisieAgentToSave?.heuresprod);
        } else if ((!CheckAttr(saisieAgentToSave?.heuresprod) ||
            !CheckAttr(saisieAgentToSave?.heures_ca)) &&
            !CheckAttr(saisieAgentToSave?.actes)) {
            isVal = false;
        }

        if (
            !CheckAttr(saisieAgentToSave?.pays) ||
            !CheckAttr(saisieAgentToSave?.article) ||
            !CheckAttr(saisieAgentToSave?.client) ||
            !CheckAttr(saisieAgentToSave?.operation) ||
            !CheckAttr(saisieAgentToSave?.date_saisie) || !isVal) {
            if (!CheckAttr(saisieAgentToSave?.pays)) {
                setErrorInput((prev: InputValidation) => ({ ...prev, pays: true }));
            }

            if (!CheckAttr(saisieAgentToSave?.article)) {
                setErrorInput((prev: InputValidation) => ({ ...prev, bu: true }));
            }

            if (!CheckAttr(saisieAgentToSave?.client)) {
                setErrorInput((prev: InputValidation) => ({ ...prev, client: true }));
            }

            if (!CheckAttr(saisieAgentToSave?.operation)) {
                setErrorInput((prev: InputValidation) => ({ ...prev, operation: true }));
            }

            if (!CheckAttr(saisieAgentToSave?.date_saisie)) {
                setErrorInput((prev: InputValidation) => ({ ...prev, date_saisie: true }));
            }

            if (!isVal) {
                setErrorInput((prev: InputValidation) => ({ ...prev, value: true }));
            }

            setAlerteMessage("Merci de remplir les champs en rouge !");
            setAlertType("warning");
            setOpenSnack(true);

            return false;
        }
        return true;
    }

    const handleSave = () => {
        if (isValidate()) {
            setIsClickSave(true);

            http.post(`saisie/manager/check-existence`, saisieAgentToSave)
                .then(res => {
                    const { saisieCount } = res.data;

                    if (saisieCount > 0) {
                        setAlerteMessage(`Il y avait déjà des heures saisis  pour la date ${dateFormat(saisieAgentToSave.date_saisie, 'dd-mm-yyyy')} !`);
                        setAlertType("warning");
                        setOpenSnack(true);
                        setIsClickSave(false);
                    } else {
                        http.put(`saisie/manager/update/${saisieAgent?.id}`, saisieAgentToSave)
                            .then(() => {
                                setAlerteMessage("Enregistrement efféctuée !");
                                setAlertType("success");
                                setOpenSnack(true);
                                onClose();
                                reloadList();
                            }).catch(error => {
                                console.log(error);
                                setAlertType("error");
                                setOpenSnack(true);
                            }).finally(() => {
                                setIsClickSave(false);
                            });
                    }
                }).catch(error => {
                    console.log(error);
                    setAlertType("error");
                    setOpenSnack(true);
                    setIsClickSave(false);
                });
        }
    }

    const disableHeureInput = (): boolean => {
        if ((!sansActes && CheckAttr(saisieAgentToSave?.actes)) ||
            checkViaCodeArticle(codeArticleNotToDisable, ['A', 'a'], saisieAgentToSave?.code_article_libelle)
            || !CheckAttr(saisieAgent?.tarifheure) ||
            saisieAgent?.article_semi_automatique === 1 ||
            [PROFIL_GESTIONNER_HEURE_PROD].includes(profil)
        ) {
            return true;
        }

        return false;
    }

    const disableActeInput = (): boolean => {
        if (sansActes ||
            CheckAttr(saisieAgentToSave?.heures_ca) ||
            checkViaCodeArticle(codeArticleNotToDisable, ['H', 'h'], saisieAgentToSave?.code_article_libelle)
            || !CheckAttr(saisieAgent?.tarifacte) ||
            saisieAgent?.article_semi_automatique === 1 ||
            [PROFIL_GESTIONNER_HEURE_PROD].includes(profil)
        ) {
            return true;
        }

        return false;
    }

    const maxDate = (): string => {
        let today = new Date();

        if (saisieAgent && saisieAgent?.article_desactive_date) {
            today = new Date(saisieAgent?.article_desactive_date);
            today.setDate(today.getDate() - 1);
        }

        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        const day = today.getDate();

        return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
    };

    const disable = saisieAgent && true;

    /*
    * Si profil user connecter est manager, et si date now >= date verouillage, alors il faut verouiller les dates compris dans les périodes
    */
    let minDate = periodSaisi?.date_debut;

    if ([PROFIL_MANAGER, PROFIL_COUNTRY_MANAGER, PROFIL_ROA].includes(profil)) {
        if (maxDate() >= periodSaisi?.date_verrouillage) {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const day = 1;

            minDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
        }
    }

    const cout = (saisieAgent?.cout && saisieAgentToSave?.heuresprod) ? (Number(saisieAgent?.cout) * Number(saisieAgentToSave?.heuresprod)) : undefined;

    const tarifHeure = saisieAgent?.tarifheure ? Number(saisieAgent?.tarifheure) : 0;
    const tarifActe = saisieAgent?.tarifacte ? Number(saisieAgent?.tarifacte) : 0;
    const heureCA = saisieAgent?.heures_ca ? Number(saisieAgent?.heures_ca) : 0;
    const acteCA = saisieAgent?.actes ? Number(saisieAgent?.actes) : 0;
    const chiffreAffaire = (tarifHeure * heureCA) + (tarifActe * acteCA);

    const staticInformations = [
        {
            label: 'PU Heure :',
            value: saisieAgent?.tarifheure && parseFloat(String(saisieAgent?.tarifheure))?.toFixed(chiffreApresVirgule)
        },
        {
            label: 'PU Acte :',
            value: saisieAgent?.tarifacte && parseFloat(saisieAgent?.tarifacte)?.toFixed(chiffreApresVirgule)
        },
        {
            label: 'CA HT :',
            value: chiffreAffaire && parseFloat(String(chiffreAffaire))?.toFixed(chiffreApresVirgule)
        },
        {
            label: 'Cout/h :',
            value: saisieAgent?.cout
        },
        {
            label: 'Cout :',
            value: cout
        },
        {
            label: 'Devise de facturation :',
            value: saisieAgent?.devises_libelle
        }
    ];

    return (
        <Fragment>
            <Box className={classes.root}>
                <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
                    <Grid item xs={6} sm={6} md={2}>
                        <FormControl variant="outlined" className={classes.formControl} sx={{ marginLeft: 1, marginTop: 1 }}>
                            <InputLabel
                                htmlFor="pays"
                                color="warning"
                                shrink
                            >
                                Pays de production
                            </InputLabel>
                            <Select
                                id="pays"
                                native
                                notched
                                color="warning"
                                disabled={disable}
                                error={errorInput.pays}
                                value={saisieAgentToSave?.pays ?? ''}
                                onChange={handleChange}
                                label="Pays de production"
                                inputProps={{
                                    name: 'pays',
                                }}
                            >
                                <option value=""></option>
                                {dataPays.map((pays) => (
                                    <option key={pays?.id} value={pays?.id}>
                                        {pays?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl} sx={{ marginLeft: 1, marginTop: 1 }}>
                            <InputLabel
                                htmlFor="client"
                                color="warning"
                                shrink
                            >
                                Client
                            </InputLabel>
                            <Select
                                id="client"
                                native
                                notched
                                color="warning"
                                disabled={disable}
                                error={errorInput.client}
                                value={saisieAgentToSave?.client ?? ''}
                                onChange={handleChange}
                                label="Client"
                                inputProps={{
                                    name: 'client',
                                }}
                            >
                                <option value=""></option>
                                {dataClients.map((client) => (
                                    <option key={client?.id} value={client?.id}>
                                        {client?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl} sx={{ marginLeft: 1, marginTop: 1 }}>
                            <InputLabel
                                htmlFor="operation"
                                color="warning"
                                shrink
                            >
                                Opérations
                            </InputLabel>
                            <Select
                                id="operation"
                                native
                                notched
                                color="warning"
                                disabled={disable}
                                error={errorInput.operation}
                                value={saisieAgentToSave?.operation ?? ''}
                                onChange={handleChange}
                                label="Opérations"
                                inputProps={{
                                    name: 'operation',
                                }}
                            >
                                <option value=""></option>
                                {dataOperations.map((operation) => (
                                    <option key={operation?.id} value={operation?.id}>
                                        {operation?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl} sx={{ marginLeft: 1, marginTop: 1 }}>
                            <InputLabel
                                htmlFor="article"
                                color="warning"
                                shrink
                            >
                                Article
                            </InputLabel>
                            <Select
                                id="article"
                                native
                                notched
                                color="warning"
                                disabled={disable}
                                error={errorInput.article}
                                value={saisieAgentToSave?.article ?? ''}
                                onChange={handleChange}
                                label="Article"
                                inputProps={{
                                    name: 'article',
                                }}
                            >
                                <option value=""></option>
                                {dataArticles.map((article) => (
                                    <option key={article?.id} value={article?.id}>
                                        {article?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            name="date_saisie"
                            label="Date saisie"
                            type="date"
                            color="warning"
                            fullWidth
                            error={errorInput.date_saisie}
                            value={saisieAgentToSave?.date_saisie ?? ''}
                            onChange={handleChange}
                            disabled={
                                saisieAgent?.article_semi_automatique === 1 ||
                                [PROFIL_GESTIONNER_HEURE_PROD].includes(profil) ||
                                (profil === PROFIL_ADV && saisieAgent?.status === 'envoyée')
                            }
                            inputProps={{
                                min: minDate,
                                max: maxDate()
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <TextField
                            name="heures_ca"
                            label="Heures CA"
                            color="warning"
                            type="number"
                            fullWidth
                            autoComplete="off"
                            error={errorInput.value}
                            value={saisieAgentToSave?.heures_ca ?? ''}
                            disabled={
                                disableHeureInput() ||
                                (profil === PROFIL_ADV && saisieAgent?.status === 'envoyée')
                            }
                            onChange={handleChange}
                            placeholder="Ex: 2.02"
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{
                                step: 0.01,
                                lang: 'en-US'
                            }}
                        />

                        <TextField
                            name="actes"
                            label="Actes"
                            color="warning"
                            type="number"
                            fullWidth
                            autoComplete="off"
                            error={errorInput.value}
                            value={saisieAgentToSave?.actes ?? ''}
                            disabled={
                                disableActeInput() ||
                                (profil === PROFIL_ADV && saisieAgent?.status === 'envoyée')
                            }
                            onChange={handleChange}
                            placeholder="Ex: 2.02"
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{
                                step: 0.01,
                                lang: 'en-US'
                            }}
                        />

                        <TextField
                            name="heuresprod"
                            label="Heures de Production"
                            color="warning"
                            fullWidth
                            autoComplete="off"
                            type="number"
                            placeholder="Ex: 2.02"
                            error={errorInput.value}
                            value={saisieAgentToSave?.heuresprod ?? ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{
                                step: 0.01,
                                lang: 'en-US'
                            }}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                        <TextField
                            name="dmt"
                            label="DMT"
                            color="warning"
                            fullWidth
                            autoComplete="off"
                            placeholder="Ex: 2.02"
                            value={saisieAgentToSave?.dmt ?? ''}
                            onChange={handleChange}
                            disabled={
                                saisieAgent?.article_semi_automatique === 1 ||
                                [PROFIL_GESTIONNER_HEURE_PROD].includes(profil) ||
                                profil === PROFIL_ADV && saisieAgent?.status === 'envoyée'
                            }
                            InputLabelProps={{
                                shrink: true
                            }}
                        />

                        {staticInformations.map((info, index) => (
                            <Stack
                                key={index}
                                direction="row"
                                spacing={2}
                                display="flex"
                                alignItems="center"
                                sx={{
                                    color: "#9E9E9E",
                                    width: '100%',
                                    height: 54,
                                    ml: 3,
                                    mt: 2
                                }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: 15 }}>{info.label}</Typography>
                                <Typography sx={{ fontSize: 15 }}>{info.value}</Typography>
                            </Stack>
                        ))}

                    </Grid>
                </Grid>
                <Box display="flex" justifyContent="center" mt={5}>
                    <LoadingButton
                        onClick={() => handleSave()}
                        endIcon={saisieAgent ? <BorderColorIcon /> : <AddIcon />}
                        loading={isClickSave}
                        loadingPosition="end"
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        color="warning"
                    >
                        {saisieAgent ? "Enregistrer" : "Ajouter"}
                    </LoadingButton>
                </Box>
            </Box >
        </Fragment>
    );
};

export default SaisieAgentForm;